import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { NotificationPrefsApiService } from '../store/notification-prefs-api.service';
import { getNotificationPreferencesComplete, setError } from '../store';
import { Store } from '@ngrx/store';
import { NotificationStatusService } from '@app/modules/communications/services/notification-status-service';

export const UserPreferencesResolver: ResolveFn<void> = async () => {
  const store = inject(Store);

  const notificationStatus = inject(NotificationStatusService);

  notificationStatus.loadNotificationRatingScale();

  const action = await inject(NotificationPrefsApiService)
    .getNotificationPreferences()
    .toPromise()
    .then(preferences => getNotificationPreferencesComplete({ preferences }))
    .catch(err => setError({ err }));

  store.dispatch(action);
};
